// Typelizer digest ee7a0b8e065760d613168d5cce849c8e
//
// DO NOT MODIFY: This file was automatically generated by Typelizer.
import type { RouteDefinition, RouteOptions } from '../runtime'
import { buildUrl } from '../runtime'

export default {
  /** POST /passkeys */
  create: (options?: RouteOptions): RouteDefinition<'post'> => ({
    url: buildUrl('/passkeys', {}, options),
    method: 'post',
  }),

  /** DELETE /passkeys/:id */
  destroy: (
    params: { id: string | number } | string | number,
    options?: RouteOptions,
  ): RouteDefinition<'delete'> => ({
    url: buildUrl('/passkeys/:id', params, options),
    method: 'delete',
  }),
}
